import { render, staticRenderFns } from "./TabsCpnu.vue?vue&type=template&id=4ab79a40&scoped=true"
import script from "./TabsCpnu.vue?vue&type=script&lang=js"
export * from "./TabsCpnu.vue?vue&type=script&lang=js"
import style0 from "./TabsCpnu.vue?vue&type=style&index=0&id=4ab79a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab79a40",
  null
  
)

export default component.exports